import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { saveAccessTokens } from '@ecp/common/src/utils/utils';
import { SSO_STATUS, useSso } from '@ecp/common/src/hooks/useSso';

import { useAlertDialog } from '@bo-hooks/common/useModal';
import authApi from '@bo-apis/common/authApi';

const SsoRoutes = () => {
  const { connect, ssoLogin, status, resultData, socketResponseData } = useSso({
    loginApi: authApi.ssoLogin,
  });
  const [routeStatus, setRouteStatus] = useState('');

  const navigate = useNavigate();
  const { showAlertDialog } = useAlertDialog();

  const updateRouteStatusBySuccessResult = useCallback(
    ({ resultCode, accessToken, refreshToken }) => {
      switch (resultCode) {
        case 'SSO-001':
          setRouteStatus('unregistered');
          break;
        case 'SSO-002':
          setRouteStatus('fail');
          break;
        case 'SSO-003':
          setRouteStatus('dormancy');
          break;
        case 'SSO-004':
          setRouteStatus('expired-password');
          break;
        case 'SSO-005':
        case 'SSO-008':
          setRouteStatus('multi-role-select');
          break;
        case 'SSO-007':
          showAlertDialog('허용된 접근이 아닙니다.');
          break;
        default:
          saveAccessTokens(accessToken, refreshToken);
          setRouteStatus('registered');
      }
    },
    [showAlertDialog]
  );

  useEffect(() => {
    connect();
  }, [connect]);

  useEffect(() => {
    switch (status) {
      case SSO_STATUS.READY:
        ssoLogin();
        break;
      case SSO_STATUS.SUCCESS:
        updateRouteStatusBySuccessResult(resultData);
        break;
      case SSO_STATUS.FAIL:
        setRouteStatus('fail');
        break;
      case SSO_STATUS.CLOSED:
        setRouteStatus('closed');
        break;
      default:
        return;
    }
  }, [status, resultData, ssoLogin, updateRouteStatusBySuccessResult]);

  useEffect(() => {
    switch (routeStatus) {
      case 'registered':
        navigate(0);
        break;
      case 'unregistered':
        navigate('unauthorized', { replace: true });
        break;
      case 'multi-role-select':
        navigate('/common/job-group-select', { state: { ssoUserInfo: socketResponseData }, replace: true });
        break;
      case 'fail':
        navigate('unauthorized', { replace: true });
        break;
      case 'dormancy':
        navigate('unauthorized', { replace: true });
        break;
      case 'expired-password':
        navigate('unauthorized', { replace: true });
        break;
      case 'closed':
        break;
      default:
        return;
    }
  }, [navigate, routeStatus, socketResponseData]);

  return <></>;
};

export default SsoRoutes;
